<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<div @click="locumViewRequest(offerRequestSet)">
					<v-list-item-title class="secondary--text font-weight-bold">{{ offerRequestSet.offer.company.name }}</v-list-item-title>
					<v-list-item-subtitle class="black--text subtitle-2 font-weight-bold"
						>{{ dateFormattedMomentjs(offerRequestSet.request.booking_dates[0]) }} -
						{{ dateFormattedMomentjs(offerRequestSet.request.booking_dates[offerRequestSet.request.booking_dates.length - 1]) }}</v-list-item-subtitle
					>
					<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
					<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>
					<!-- <v-list-item-subtitle class="black--text lighten-1 font-weight-bold"
					>{{ offerRequestSet.offer.start_time }} - {{ offerRequestSet.offer.end_time }}</v-list-item-subtitle
				> -->
					<v-list-item-subtitle class="primary--text font-weight-bold">#{{ offerRequestSet.request.uniqueAppReference }}</v-list-item-subtitle>
				</div>
				<v-row no-gutters>
					<v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="primary" bottom overlap bordered>
						<v-btn
							v-if="showMessageValid(offerRequestSet.request.booking_dates[offerRequestSet.request.booking_dates.length - 1])"
							class="white--text button-rounded mt-2"
							:height="25"
							color="accent"
							@click="openMessageDialog()"
							><span style="font-size: 12px">Message</span></v-btn
						>
					</v-badge>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="locumViewRequest(offerRequestSet)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';

export default {
	name: 'LocumApplicationSentCard',
	components: {},
	props: {
		offerRequestSet: { type: Object, required: true },
	},

	data: () => ({
		showTimes: true,
		start_time: '',
		end_time: '',
		unreadMessageCount: 0,
	}),

	async mounted() {
		await this.getUnreadMessageCount();
		this.getTimes();
	},

	methods: {
		...mapActions('message', ['GetConversationUnreadCount']),
		locumViewRequest(availability) {
			const { offer, request } = availability;
			const { company, start_time, end_time, lunch, notes, id: offerId, profession, rates, experience, skills, request_dates } = offer;
			const { booking_dates, booking_dates_times, id: requestId, rates: requestRates } = request;
			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates,
				booking_dates_times,
				id: offerId,
				requestId,
				profession,
				rates,
				experience,
				skills,
				request_dates,
				requestRates,
				company,
			};
			store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewApplicationSent' });
			bus.$emit('change-context', 'view-practice-details-card');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},
		getTimes() {
			this.showTimes = true;
			this.start_time = this.offerRequestSet.offer.start_time;
			this.end_time = this.offerRequestSet.offer.end_time;
			for (let index = 0; index < this.offerRequestSet.offer.request_dates.length; index++) {
				if (
					moment(this.offerRequestSet.offer.request_dates[index].start_time).format('HH:mm') !== this.offerRequestSet.offer.start_time ||
					moment(this.offerRequestSet.offer.request_dates[index].end_time).format('HH:mm') !== this.offerRequestSet.offer.start_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},

		openMessageDialog() {
			const sentByID = this.offerRequestSet.request.id;
			let receiverDetails = {
				id: this.offerRequestSet.offer.company.id,
				name: this.offerRequestSet.offer.company.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
		},

		showMessageValid(reqEndDate) {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');
			if (reqEndDate >= dateString) return true;
			else return false;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.offerRequestSet.request.id,
				sentByID: this.offerRequestSet.offer.company.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
